import { CLEAN_URL, PARAMS, JPOST, JGET, TGET } from 'iotera-base/webservice'
import {
    APP_GET, APP_POST, APP_POST_W_TIMEOUT,
    TENANT_GET, TENANT_POST, TENANT_POST_W_TIMEOUT,
    DOMAIN_POST, DOMAIN_POST_W_TIMEOUT, APP_TGET
} from './'
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isInteger, isNone, isString } from 'iotera-base/object';
import { isTextEmpty } from 'iotera-base/text';
import Result from 'iotera-base/result';
import { appToken, tenantToken } from '../auth/token';
import { WEBSERVICE, WEBSERVICE_FETCH, WEBSERVICE_STORAGE } from '../lib/components/Preference';

// export const BASE_SERVICE_URL = !isNone(window._env_.BASE_SERVICE_URL) ? window._env_.BASE_SERVICE_URL : 'https://sv.iotera.io/';
// export const BASE_FETCH_URL = !isNone(window._env_.BASE_FETCH_URL) ? window._env_.BASE_FETCH_URL : 'https://f.iotera.io/';
export const BASE_SERVICE_URL = !isNone(window._env_.BASE_SERVICE_URL) ? window._env_.BASE_SERVICE_URL : 'https://dev-svc.iotera.biz.id/';
export const BASE_FETCH_URL = !isNone(window._env_.BASE_FETCH_URL) ? window._env_.BASE_FETCH_URL : 'https://dev-f.iotera.biz.id/';
export const BASE_STATIC_URL = !isNone(window._env_.BASE_STATIC_URL) ? window._env_.BASE_STATIC_URL : 'https://cdn.iotera.io/v0/';


export const DEFAULT_TIMEOUT = isInteger(window._env_.DEFAULT_TIMEOUT) ? window._env_.DEFAULT_TIMEOUT : 30000;

export function REQUEST(wparam) {
    const method = safeDeepGet(wparam, ['method'], 'GET');
    let url = safeDeepGet(wparam, ['url']);
    const path = safeDeepGet(wparam, ['path']);
    const domain = safeDeepGet(wparam, ['domain']);
    const usingAuth = safeDeepGetWithType(wparam, ['usingAuth'], true);
    const type = safeDeepGetWithType(wparam, ['type'], WEBSERVICE);
    const responseType = safeDeepGetWithType(wparam, ['responseType'], 'json');

    if (isTextEmpty(url) && isTextEmpty(path)) {
        return {
            code: Result.INPUT_FAILURE,
            text: Result.Message.get(Result.INPUT_FAILURE),
            headers: null,
            body: null
        }
    } else if (!isTextEmpty(path)) {
        if (type === WEBSERVICE) {
            url = CLEAN_URL(BASE_SERVICE_URL + path);
        } else if (type === WEBSERVICE_FETCH) {
            url = CLEAN_URL(BASE_FETCH_URL + path);
        }
    }

    const param = safeDeepGet(wparam, ['params']);
    if (param != null) {
        if (param['period'] === 'march') {
            delete param['period'];
            param['start'] = '1582995600000';
            param['end'] = '1585673999999';
        } else if (param['period'] === 'april') {
            delete param['period'];
            param['start'] = '1585674000000';
            param['end'] = '1588265999999';
        } else if (param['period'] === 'may') {
            delete param['period'];
            param['start'] = '1588266000000';
            param['end'] = '1590944399999';
        }
    }
    url += PARAMS(param);
    wparam['url'] = url

    if (responseType === 'json') {
        if (!isString(domain)) {

            const token = tenantToken();
            if (!usingAuth) {

                wparam['timeout'] = DEFAULT_TIMEOUT;
                if (method === 'GET') {
                    return JGET(wparam);
                }
                else if (method === 'POST') {
                    return JPOST(wparam);
                }

            } else {

                if (method === 'GET') {
                    return TENANT_GET(url, token);
                } else if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return TENANT_POST(url, token, body);
                    } else {
                        return TENANT_POST_W_TIMEOUT(url, token, body, timeout);
                    }
                }
            }

        } else {

            if (!usingAuth) {

                if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return DOMAIN_POST(url, domain, body);
                    } else {
                        return DOMAIN_POST_W_TIMEOUT(url, domain, body, timeout);
                    }
                }

            } else {

                const isTenant = safeDeepGetWithType(wparam, ['isTenant'], true);
                const token = appToken(domain, isTenant);
                if (method === 'GET') {
                    return APP_GET(url, token);
                } else if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return APP_POST(url, token, body);
                    } else {
                        return APP_POST_W_TIMEOUT(url, token, body, timeout);
                    }
                }
            }
        }
    } else if (responseType === 'text') {
        if (!isString(domain)) {
            const token = tenantToken();
            if (!usingAuth) {
                if (method === 'GET') {
                    return TGET(wparam);
                }
                else if (method === 'POST') {
                    return JPOST(wparam);
                }

            } else {

                if (method === 'GET') {
                    return TENANT_GET(url, token);
                } else if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return TENANT_POST(url, token, body);
                    } else {
                        return TENANT_POST_W_TIMEOUT(url, token, body, timeout);
                    }
                }
            }

        } else {

            if (!usingAuth) {

                if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return DOMAIN_POST(url, domain, body);
                    } else {
                        return DOMAIN_POST_W_TIMEOUT(url, domain, body, timeout);
                    }
                }

            } else {

                const isTenant = safeDeepGetWithType(wparam, ['isTenant'], true);
                const token = appToken(domain, isTenant);
                if (method === 'GET') {
                    return APP_TGET(url, token);
                } else if (method === 'POST') {
                    let body = safeDeepGet(wparam, ['body']);
                    let timeout = safeDeepGet(wparam, ['timeout']);
                    if (isNone(timeout)) {
                        return APP_POST(url, token, body);
                    } else {
                        return APP_POST_W_TIMEOUT(url, token, body, timeout);
                    }
                }
            }
        }
    }

    return {
        code: Result.INPUT_FAILURE,
        text: Result.Message.get(Result.INPUT_FAILURE),
        headers: null,
        body: null
    }
}
